import Decorator from '.'
import { ActivityMiddleware } from 'botframework-webchat-api'

export const editUserActivityMiddleware: ActivityMiddleware =
  () =>
  next =>
  (...setupArgs) => {
    const [card] = setupArgs
    const { activity } = card
    const activityId = activity?.id

    if (
      activityId !== undefined &&
      activity?.from?.role === 'user' &&
      activity?.type === 'message'
    ) {
      const renderCard = next(card)

      if (renderCard === false) {
        return renderCard
      }

      return (...renderArgs) => {
        return (
          <Decorator activityId={activityId} key={activityId}>
            {renderCard(...renderArgs)}
          </Decorator>
        )
      }
    } else {
      return next(...setupArgs)
    }
  }
